import script from "./Table2.vue?vue&type=script&setup=true&lang=js"
export * from "./Table2.vue?vue&type=script&setup=true&lang=js"

import "./Table2.vue?vue&type=style&index=0&id=218712fe&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-218712fe"]])

export default __exports__